import { Component, OnInit } from '@angular/core';
import { MemberService } from 'src/app/services/member.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-staff-member',
  templateUrl: './staff-member.component.html',
  styleUrls: ['./staff-member.component.scss']
})
export class StaffMemberComponent implements OnInit {
  public loading:boolean=true;
  public member;
  public memberId;

  constructor(
    private _member: MemberService,
    private _notify: NotificationService,
    private _route: ActivatedRoute
  ) {
    this.memberId=this._route.snapshot.paramMap.get('id');
  }

  getMember(){
    this._member.getMember(this.memberId).subscribe(
      res=>{
        this.member=res;
        this.loading=false;
      }
    );
  }

  deactivateAccount(){
    this._member.updateAdministratorStatus(this.memberId, 1).subscribe(
      res=>{
        this._notify.showMessage(res.message, 'OK');
        this.getMember();
      }
    );
  }

  enableAccount(){
    this._member.updateAdministratorStatus(this.memberId, 0).subscribe(
      res=>{
        this._notify.showMessage(res.message, 'OK');
        this.getMember();
      }
    );
  }

  ngOnInit() {
    this.getMember();
  }

}
